import { useEffect, useState } from "react";
import ic_clock from "../../assets/icons/ic_clock.svg";
import { getStartedExercise } from "../../api/api";
import Button from "../basic/Button";
import AuthDialog from "../auth/AuthDialog";
import more_exercise from "../../assets/images/more_exercise.png";
import { useAuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Playlist } from "../home/Playlists";
import { WhiteLinearGradient } from "../../utils/Utils";
import { ExerciseCard } from "../playlistDialog/Exercise";

function GettingStarted() {
  const authContext = useAuthContext();
  const navigate = useNavigate();
  const [exercises, setExercises] = useState([]);
  const [playlists, setplaylists] = useState([]);
  const [showAuth, setShowAuth] = useState(false);

  async function fetchExercies() {
    const response = await getStartedExercise();

    setExercises([response[0], response[1]]);
    setplaylists([response[2], response[3], response[4]]);
  }

  useEffect(() => {
    fetchExercies();
  }, []);

  return (
    <div
      className={`flex flex-1 flex-col ${WhiteLinearGradient} px-10 md:px-32 py-10`}
    >
      {/* <p className="text-white text-4xl font-bold text-center w-full">Try our Exercises</p>fix */}
      <div className="my-14 flex justify-center items-center space-y-5 flex-col">
        <div className="grid grid-cols-1 md:grid-cols-3 w-full gap-5 z-0">
          {exercises.map((exercise, index) => {
            return (
              <ExerciseCard
                exerciseName={exercise.exerciseName}
                description={exercise.exercisesBenefits}
                details={[
                  {
                    icon: ic_clock,
                    text: exercise.exercisesDuration + " secs",
                    alwaysShow: true,
                  },
                ]}
                exerciseUri={exercise.exerciseURI}
                id={exercise.exerciseId}
                exerciseImage={exercise.activityImage}
                exerciseAudio={exercise.exerciseAudio}
                exerciseVideo={exercise.exerciseVideo}
                allowStart
                showInstructionBeforeRedirect
                exerciseUrl={exercise.url}
                addToPlaylist={false}
                key={index}
              />
            );
          })}
          {playlists.map((playlist, index) => {
            return <Playlist {...playlist} key={index} />;
          })}
          <div
            style={{ backgroundImage: `url(${more_exercise})` }}
            className=" flex justify-center items-center -z-0  h-52 p-4 bg-center  bg-cover rounded-lg flex-col"
          >
            {!authContext.state.user && (
              <p className="text-center self-center text-2xl font-bold text-white">
                For more modules and exercises
              </p>
            )}
            <Button
              className={"max-w-max mt-4 bg-white self-center"}
              onClick={() => {
                if (authContext.state.user) {
                  navigate("/programpage");
                } else {
                  setShowAuth(true);
                }
              }}
            >
              <p className="text-white">
                {authContext.state.user ? "View more" : "Login Now"}
              </p>
            </Button>
          </div>
        </div>
        <AuthDialog open={showAuth} setOpen={setShowAuth} />
      </div>
    </div>
  );
}

export default GettingStarted;
